import React, { useEffect, useMemo, useState } from 'react';
import { useEntryPoint } from '@atlassian/jira-entry-point';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container';
import { useConfettiColumns } from '../../../../../controllers/column-confetti-old';
import { boardConfettiEntrypoint } from './entrypoint';

const entryPointParams = {};
export const BoardConfettiAsync = ({ columnId }: { columnId: number }) => {
	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		boardConfettiEntrypoint,
		entryPointParams,
	);
	const [animating, setAnimating] = useState(false);
	const [{ confettiColumns }, { removeConfettiColumn }] = useConfettiColumns();

	useEffect(() => {
		if (confettiColumns.has(columnId)) {
			setAnimating(true);
			removeConfettiColumn(columnId);
		}
	}, [confettiColumns, removeConfettiColumn, columnId]);

	useEffect(() => {
		if (animating) {
			entryPointActions.load();
		}
	}, [animating, entryPointActions]);

	const runtimeProps = useMemo(
		() => ({
			onConfettiComplete: () => setAnimating(false),
		}),
		[setAnimating],
	);

	if (!animating) {
		return null;
	}

	return (
		<JiraEntryPointContainer
			id="jwm-board-confetti"
			packageName="jiraWorkManagementBoard"
			entryPointReferenceSubject={entryPointReferenceSubject}
			fallback={null}
			runtimeProps={runtimeProps}
		/>
	);
};
